import { Expression } from '../types/expression'
import { truthy } from './types/boolean'

export function expressionSome(...expressions: (Expression | null | undefined)[]): Expression {
  const filtered = expressions.filter(truthy)

  if (filtered.length === 0) {
    return {
      type: 'expression',
      kind: 'literal',
      value: false,
      literalType: 'boolean',
    }
  }
  if (filtered.length === 1) {
    return filtered[0]
  }

  return filtered.reduce((acc, expression) => ({
    type: 'expression',
    kind: 'binary',
    operator: 'OR',
    left: expression,
    right: acc,
  }))
}

export function expressionEvery(...expressions: (Expression | null | undefined)[]): Expression {
  const filtered = expressions.filter(truthy)

  if (filtered.length === 0) {
    return {
      type: 'expression',
      kind: 'literal',
      value: true,
      literalType: 'boolean',
    }
  }
  if (filtered.length === 1) {
    return filtered[0]
  }

  return filtered.reduce((acc, expression) => ({
    type: 'expression',
    kind: 'binary',
    operator: 'AND',
    left: expression,
    right: acc,
  }))
}

export function iterateAndCheckIfSomeExpression(
  expression: Expression,
  predicate: (expression: Expression) => boolean,
): boolean {
  if (predicate(expression)) {
    return true
  }
  switch (expression.kind) {
    case 'binary':
      return (
        iterateAndCheckIfSomeExpression(expression.left, predicate) ||
        iterateAndCheckIfSomeExpression(expression.right, predicate)
      )
    case 'ternary':
      return (
        iterateAndCheckIfSomeExpression(expression.condition, predicate) ||
        iterateAndCheckIfSomeExpression(expression.whenTrue, predicate) ||
        iterateAndCheckIfSomeExpression(expression.whenFalse, predicate)
      )
    case 'unary':
      return iterateAndCheckIfSomeExpression(expression.operand, predicate)
    case 'summation':
    case 'function':
      return expression.arguments.some(arg => iterateAndCheckIfSomeExpression(arg, predicate))
    case 'list':
      return expression.items.some(item => iterateAndCheckIfSomeExpression(item, predicate))
    default:
      return false
  }
}
